import type { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LogoPatroclo } from './LogoPatroclo';

/**
 * Las partes de la pestaña de Patroclo: el chat, la base de conocimiento y las
 * trazas.
 *
 * Hoy la pestaña entera es de administrador y desarrollador, así que las tres
 * se ven siempre. **El día que el chat se abra a otros roles, documentos y
 * trazas siguen siendo solo de esos dos**: aquí se filtrará, pero la regla de
 * verdad ya está en el proxy (`@Roles` por ruta) y en Patroclo.
 */
export function NavPatroclo(): ReactNode {
  const { pathname } = useLocation();
  // El chat vive en `/patroclo` y en `/patroclo/:id`: está activo en todo lo
  // que no sea documentos ni trazas.
  const enChat = !pathname.startsWith('/patroclo/documentos') && !pathname.startsWith('/patroclo/trazas');

  const clase = (activo: boolean): string =>
    `flex min-h-[44px] items-center rounded-full px-4 text-sm transition sm:min-h-0 sm:py-1.5 ${
      activo ? 'bg-acento font-medium text-white shadow-sm' : 'text-tenue hover:bg-acento-tenue hover:text-marino'
    }`;

  return (
    // `flex-wrap`: con el logo y tres enlaces no cabe en un teléfono, y «Trazas»
    // quedaba cortado.
    <nav aria-label="Patroclo" className="flex flex-wrap items-center gap-1 gap-y-2 border-b border-borde pb-3">
      <span className="mr-2 flex items-center gap-2 font-titulo text-xl font-semibold text-marino">
        <LogoPatroclo className="h-9 w-9" />
        Patroclo
      </span>
      <NavLink to="/patroclo" end className={() => clase(enChat)}>
        Chat
      </NavLink>
      <NavLink to="/patroclo/documentos" className={({ isActive }) => clase(isActive)}>
        Documentos
      </NavLink>
      <NavLink to="/patroclo/trazas" className={({ isActive }) => clase(isActive)}>
        Trazas
      </NavLink>
    </nav>
  );
}
